import { render, staticRenderFns } from "./EcStatusBadge.vue?vue&type=template&id=d1cc2096"
import script from "./EcStatusBadge.vue?vue&type=script&lang=js"
export * from "./EcStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports